import axios from 'axios';
import { GraphURL } from '../config/app';
import Alert from 'react-s-alert';
import _ from 'lodash';

class Graph {
    constructor() {
        this.instance = axios.create({
            baseURL: GraphURL,
            timeout: 30000,
            transformRequest: this.transform,
            headers: {}
        })
    }

    getToken() {
        let token = sessionStorage.getItem('token');
        if(!token) return false;

        return token;
    }
    
    get(uri,params, dispatch) {
        params = params.replace(/\s|\n|\r/g, '');
        return this.instance.get(`${uri}?query=${params}`, {
            params: {
                token: this.getToken(),
                ...params
            }
        })
        .then(response => {
            const { data } = response
            return data;
        })
    }

    post(url, params, dispatch) {
        let newUrl = `${url}?token=${this.getToken()}`;
        if(url.indexOf('?') > -1){
            newUrl = `${url}&token=${this.getToken()}`
        }
        if(_.isEmpty(this.getToken())) {
            newUrl = url;
        }

        //override token
        if(!_.isNil(params.token)) {
            newUrl = `/${url}?token=${params.token}`;
        }


        return this.instance.post(newUrl, params)
            .then(response => {
                const { data } = response;
                if(!_.isNil(data.errors)) {
                    Alert.error(data.errors[0].message);
                    return false;
                }
                return data;
            })
    }

    transform(object) {
        let arr = [];
        for(let p in object) {
            if(object.hasOwnProperty(p)) {
                arr.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]))
            }
        }

        return arr.join("&");
    }
}

export const graphTransform = (object) => {

    let arr = [];
    for(let p in object) {
        if(object.hasOwnProperty(p) && !Array.isArray(object[p])) {
            let value = object[p];
            if(typeof value === "number"){
                // eslint-disable-next-line
                arr.push(p + ':' + object[p])
            }else{
                // eslint-disable-next-line
                arr.push(p + ':"' + object[p] + '"')
            }
        }

        if(Array.isArray(object[p])){

            object[p].forEach((item, key) => {
                // eslint-disable-next-line
                arr.push(`${p}[${key}]` + ':"' + item + '"')
            })
        }

    }
    
    return arr.join(" ");
}

// eslint-disable-next-line
export default new Graph();


/** WEBPACK FOOTER **
 ** ./src/Graph.js
 **/